import { NumericFormat } from 'react-number-format';

export const toNumber = (number, fixed = 5, status = false) => {
  if (!number || isNaN(number)) {
    if (status) {
      return Number(0).toFixed(fixed);
    }
    return '0.00';
  }
  if (status) {
    return Number(number).toFixed(fixed).toLocaleString();
  }
  return Number(Number(number).toFixed(fixed)).toLocaleString();
};

export const toNumberTag = (number = 0, fixed = 5) => {
  if (!number || isNaN(number)) {
    return '0.00';
  }
  return <NumericFormat value={Number(Math.floor(number * (10 ** fixed))) / (10 ** fixed)} displayType="text" thousandSeparator />;
};

export const formatTime = (time) => {
  if (time && !isNaN(time)) {
    const minutes = Math.floor(time / 60);
    const formatMinutes =
      minutes < 10 ? `0${minutes}` : `${minutes}`;
    const seconds = Math.floor(time % 60);
    const formatSeconds =
      seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${formatMinutes}:${formatSeconds}`;
  }
  return '00:00';
};

export const getSecondsElapsedToday = (timeInterval) => {
  const secondsElapsed = Math.floor((getElapsedTimeFromTodayInMs('Europe/Berlin')) / 1000);

  return timeInterval - secondsElapsed % timeInterval;
};

function getElapsedTimeFromTodayInMs(timeZone) {
  // Get the current date and time in the specified time zone
  const options = {
    timeZone: timeZone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  };
  const currentTimeInTimeZone = new Intl.DateTimeFormat('en-US', options).format(new Date());
  const currentDateInTimeZone = new Date(currentTimeInTimeZone);

  // Get the midnight of the current day in the specified time zone
  const midnightInTimeZone = new Date(
    currentDateInTimeZone.getFullYear(),
    currentDateInTimeZone.getMonth(),
    currentDateInTimeZone.getDate()
  );

  // Calculate the elapsed time in milliseconds
  const elapsedTimeMs = currentDateInTimeZone.getTime() - midnightInTimeZone.getTime();

  return elapsedTimeMs;
}
